import module from 'nominas/sumario/module.js'
import template from './template.html'

const catalogoMoneda = [
  {id: 1, descripcion: 'MXN'},
  {id: 2, descripcion: 'USD'},
]

const catalogoTipoNomina = [
  {id: null, descripcion: 'Todas'},
  {id: 0, descripcion: 'Especial'},
  {id: 1, descripcion: 'Semanal'},
  {id: 2, descripcion: 'Decenal'},
  {id: 3, descripcion: 'Quincenal'},
  {id: 4, descripcion: 'Mensual'},
  {id: 5, descripcion: 'Catorcenal'},
  {id: 6, descripcion: 'Finiquito'},
]

const catalogoEstatus = [
  {id: null, descripcion: 'Todos'},
  {id: 'A', descripcion: 'Abierta'},
  {id: 'P', descripcion: 'Pendiente'},
  {id: 'C', descripcion: 'Cerrada'},
]

export class NominasSumarioFiltrosComponent {
  data
  proyectos
  onChange
  catalogo = {
    moneda: catalogoMoneda,
    tipoNomina: catalogoTipoNomina,
    estatus: catalogoEstatus,
  }
}

module.component('nominasSumarioFiltros', {
  controller: NominasSumarioFiltrosComponent,
  template,
  bindings: {
    data: '<',
    proyectos: '<',
    onChange: '&',
  },
})



// WEBPACK FOOTER //
// ./src/nominas/sumario/components/filtros/component.js